import { f7 } from 'framework7-react';
import { useEffect, useMemo, useRef, useState } from 'react';

interface PickerSelectHookProps {
  initialSelect: string;
  selectList: string[];
  pickerName: string;
}

export const usePickerSelect = ({
  initialSelect,
  selectList,
  pickerName,
}: PickerSelectHookProps) => {
  const pickerRef = useRef<any>(null);
  const [pickerList, setPickerList] = useState<string[]>([]);
  useEffect(() => {
    setPickerList(selectList);
  }, [selectList]);
  const [pickerSelect, setPickerSelect] = useState(initialSelect);
  useEffect(() => {
    setPickerSelect(initialSelect);
  }, [initialSelect]);

  const pickerInputID = useMemo(() => `${pickerName}-picker-input`, []);
  const pickerContainerID = useMemo(() => `${pickerName}-picker-container`, []);

  useEffect(() => {
    if (!pickerRef.current && pickerList?.length > 0) {
      pickerRef.current = f7.picker.create({
        inputEl: `#${pickerInputID}`,
        containerEl: `#${pickerContainerID}`,
        toolbar: false,
        value: [pickerSelect],
        on: {
          change: function (picker) {
            const [value] = picker.value as string[];
            setPickerSelect(value);
          },
        },
        cols: [
          {
            textAlign: 'center',
            values: pickerList,
          },
        ],
      });
    }
  }, [pickerList, pickerSelect]);

  return { pickerSelect, pickerInputID, pickerContainerID };
};
